export default __webpack_public_path__ + "static/media/tick.1d504933.svg";